import React, { FunctionComponent } from 'react'
import { useAuthentication } from '../hooks/useAuthentication'

const Welcome: FunctionComponent = () => {
  const { authState } = useAuthentication()

  if (!authState.authUser && authState.authUser.id === '') return null

  return (
    <div className="col-xs-8">
      <div className="user-info-footer">
        <span className="user-name">
          {authState.authUser.first_name} {authState.authUser.last_name}
        </span>
        <span className="user-details">
          • {authState.authUser.branch} • {authState.authUser.user_role?.name}
        </span>

        {authState.authUser.impersonated_by && (
          <span className="impersonation-badge">
            (Impersonated by {authState.authUser.impersonated_by})
          </span>
        )}
      </div>
    </div>
  )
}

export default Welcome
